/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import Box from '@mui/material/Box'
import HeroHeader from 'src/components/shared/modules/heroHeader/HeroHeader'
import { AccordianContent, contentType } from 'src/types/components/shared/atom'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store/store'
import Report from 'src/components/pages/report/Report'
import { reportReportAbuse } from 'src/types/store'
// import { useGetPageByNameQuery } from 'src/store/ApiCall/pagesAPI'
import HeadTag from 'src/components/layout/head'
import Skeleton from 'src/components/shared/modules/skeleton'
import { apiFetch } from '../service/api.service';

interface IProps {
  data?: any
}
export default function ReportPage({ data }: IProps) {
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)
  // const { data } = useGetPageByNameQuery('report')
  const [heroHeader, setHeroHeader] = React.useState<contentType>()

  const [reportContent, setReportContent] = React.useState<{
    reportAbuse: reportReportAbuse
    accordianContent: AccordianContent
  }>()

  React.useEffect(() => {
    if (data && data.data.length > 0) {
      const { heroHeader, reportAbuse, frequentlyAskedQuestions } =
        data.data[0].attributes
      //extracting heroHeader from data
      if (heroHeader) {
        const heroContent: contentType = {
          content: {
            secondary: {
              content: heroHeader.secondaryText,
              variant: 'h3',
              type: 'secondary',
            },
            primary: {
              content: heroHeader.primaryText,
              variant: 'h1',
              type: 'primary',
            },
            tertiary: {
              content: heroHeader.tertiaryText,
              variant: 'subtitle1',
              type: 'tertiary',
            },
          },
          topics: [],
        }
        setHeroHeader(heroContent)
      }

      //extracting reportAbuse from data
      if (reportAbuse && frequentlyAskedQuestions) {
        const reportAbuseContent = reportAbuse
        const accordianContent = {
          heading: '',
          accordianData: frequentlyAskedQuestions.faqCard.map((curr: any) => {
            return {
              desc: curr.text,
              title: curr.heading,
            }
          }),
        }
        setReportContent({
          accordianContent,
          reportAbuse: reportAbuseContent,
        })
      }
    }
  }, [data])
  return (
    <>
      <HeadTag
        title={data?.data[0].attributes.metaTitle}
        description={data?.data[0].attributes.metaDescription}
      />
      <Box component="div">
        {heroHeader ? (
          <HeroHeader
            searchField={false}
            endAdornment={false}
            placeHolder="Get help Now..."
            heroContent={heroHeader}
          />
        ) : (
          <Skeleton />
        )}{' '}
        {reportContent ? (
          <Report content={reportContent} zenMode={zenMode} />
        ) : (
          ''
        )}
      </Box>
    </>
  )
}

// This gets called on every request
export async function getServerSideProps() {
  // Fetch data from external API
  const baseURL =
    process.env.NEXT_PUBLIC_BACKEND_URL ||
    'https://strapi-beta.ditchthelabel.org'
  const endPoint =
    process.env.NEXT_PUBLIC_SITE_LANGUAGE === 'en'
      ? `/api/article-schemas?filters[name][$eq]=report&populate=deep`
      : `/api/article-schemas?filters[name][$eq]=mx-report&populate=deep&locale=es-MX`
  const url = baseURL + endPoint

  const data = await apiFetch(url)

  // Pass data to the page via props
  return { props: { data } }
}
